import { helperText } from '../../helpers/mergeFieldHelperText'

export default [
  { name: 'Session', prop: 'session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name' },
  { name: 'Text', prop: 'text', type: 'text' },
  { name: 'Link URL', prop: 'link_url', type: 'text', helperText },
  { name: 'Start (optional)', prop: 'start_at', type: 'datetime' },
  { name: 'End (optional)', prop: 'end_at', type: 'datetime' }
]
